(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owc-video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('owc-video-banner')) {
    class OwcVideoBanner extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('[data-vb-video]');
        if (!this.video) return;

        this.toggleBtn = this.querySelector('[data-vb-toggle]');
        this.mq = window.matchMedia('(min-width: 750px)');
        this.begun = false;
        this.inView = false;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = !!(navigator.connection && navigator.connection.saveData);
        // Reduced motion or data saver: never auto-download the video. Visitor can still press Play.
        this.userPaused = reducedMotion || saveData;

        this.video.muted = true;
        this.video.defaultMuted = true;

        this.onClick = () => this.toggle();
        this.onPlaying = () => {
          this.classList.add('has-played');
          this.setButton(true);
        };
        this.onMq = () => this.sourceChanged();
        this.onVisibility = () => (document.hidden ? this.softPause() : this.tryPlay());

        if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.onClick);
        this.video.addEventListener('playing', this.onPlaying);
        this.mq.addEventListener('change', this.onMq);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.setButton(!this.userPaused);

        // Wait for the page (and the LCP image) to finish loading before touching the video.
        const idle = (fn) =>
          'requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 200);
        const begin = () => {
          if (!this.isConnected) return;
          this.begun = true;
          this.observer = new IntersectionObserver(
            (entries) => {
              this.inView = entries[entries.length - 1].isIntersecting;
              this.inView ? this.tryPlay() : this.softPause();
            },
            { threshold: 0.15 }
          );
          this.observer.observe(this);
          this.updateButtonVisibility();
        };

        if (document.readyState === 'complete' || (window.Shopify && window.Shopify.designMode)) {
          idle(begin);
        } else {
          window.addEventListener('load', () => idle(begin), { once: true });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mq) this.mq.removeEventListener('change', this.onMq);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      currentSrc() {
        return (this.mq.matches ? this.dataset.srcDesktop : this.dataset.srcMobile) || '';
      }

      tryPlay() {
        this.updateButtonVisibility();
        const src = this.currentSrc();
        if (!src || this.userPaused || !this.inView || document.hidden) return;

        if (this.video.getAttribute('src') !== src) this.video.src = src;

        const attempt = this.video.play();
        if (attempt && attempt.catch) {
          attempt.catch((err) => {
            // Autoplay refused (e.g. iOS Low Power Mode): keep the image, offer a Play button.
            if (err && err.name === 'NotAllowedError') {
              this.userPaused = true;
              this.setButton(false);
            }
          });
        }
      }

      softPause() {
        if (this.video && !this.video.paused) this.video.pause();
      }

      toggle() {
        if (this.video.paused) {
          this.userPaused = false;
          this.setButton(true);
          this.tryPlay();
        } else {
          this.userPaused = true;
          this.video.pause();
          this.setButton(false);
        }
      }

      sourceChanged() {
        const src = this.currentSrc();
        if (this.video.getAttribute('src') === src) return;
        this.video.pause();
        this.classList.remove('has-played');
        if (src) {
          this.tryPlay();
        } else {
          this.video.removeAttribute('src');
          this.video.load();
          this.updateButtonVisibility();
        }
      }

      setButton(playing) {
        if (!this.toggleBtn) return;
        this.toggleBtn.classList.toggle('is-paused', !playing);
        this.toggleBtn.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
      }

      updateButtonVisibility() {
        if (this.toggleBtn) this.toggleBtn.hidden = !(this.begun && this.currentSrc());
      }
    }

    customElements.define('owc-video-banner', OwcVideoBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
